<template>
  <router-link :to="'/course/' + item.id">
    <div class="col-12">
      <div class="row">
        <div class="body-course">
          <div class="body-course-left">
            <img
              :src="icons[item.id - 1].icon"
              alt=""
              width="100%">
          </div>
          <div class="body-course-right"><p>{{ icons[item.id - 1].name }}</p></div>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
  import rating from '../include/rating'
  import ApiConfig from '../../communicate/ApiConfig'

  export default {
    name: 'CourseItem',
    components: {
      rating: rating
    },

    // eslint-disable-next-line vue/require-prop-types
    props: ['item'],
    data: function() {
      return {
        base_url: ApiConfig.base_url,
        icons: [
          {
            icon: require("@/assets/sesson/Ti.png"),
            name: "Tuổi Tý"
          },
          {
            icon: require("@/assets/sesson/Suu.png"),
            name: "Tuổi Sửu"
          },
          {
            icon: require("@/assets/sesson/Dan.png"),
            name: "Tuổi Dần"
          },
          {
            icon: require("@/assets/sesson/Mao.png"),
            name: "Tuổi Mão"
          },
          {
            icon: require("@/assets/sesson/Thin.png"),
            name: "Tuổi Thìn"
          },
          {
            icon: require("@/assets/sesson/Ran.png"),
            name: "Tuổi Tỵ"
          },
          {
            icon: require("@/assets/sesson/Ngo.png"),
            name: "Tuổi Ngọ"
          },
          {
            icon: require("@/assets/sesson/Mui.png"),
            name: "Tuổi Mùi"
          },
          {
            icon: require("@/assets/sesson/Than.png"),
            name: "Tuổi Thân"
          },
          {
            icon: require("@/assets/sesson/Dau.png"),
            name: "Tuổi Dậu"
          },
          {
            icon: require("@/assets/sesson/Tuat.png"),
            name: "Tuổi Tuất"
          },
          {
            icon: require("@/assets/sesson/Hoi.png"),
            name: "Tuổi Hợi"
          }
        ]
      }
    },

    methods: {

    }
  }
</script>

<style scoped>
  .body-course {
    width: 100%;
    height: auto;
    display: -webkit-flex; /* Safari */
    display: flex;
    padding: 5px 0;
  }

  .body-course .body-course-left {
    -webkit-flex-grow: 0; /* Safari 6.1+ */
    -webkit-flex-shrink: 0; /* Safari 6.1+ */
    -webkit-flex-basis: 30%; /* Safari 6.1+ */
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: 30%;
  }

  .body-course .body-course-right {
    -webkit-flex-grow: 0; /* Safari 6.1+ */
    -webkit-flex-shrink: 0; /* Safari 6.1+ */
    -webkit-flex-basis: 30%; /* Safari 6.1+ */
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: 70%;
    font-size: .9rem;
  }

  .body-course .body-course-right p {
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding-left: 10px;
    color: #000;
  }
</style>



// WEBPACK FOOTER //
// src/components/course/CourseItem.vue